const hasSubareas = (caName) => {
    const subareaNames = ['Bloomsbury', 'Denmark Street', 'Seven Dials']

    return (subareaNames.some(name => {return name===caName}))
}

export default hasSubareas
